import { render, staticRenderFns } from "./jefe_admin.vue?vue&type=template&id=1f67dd0c&scoped=true"
import script from "./jefe_admin.vue?vue&type=script&lang=js"
export * from "./jefe_admin.vue?vue&type=script&lang=js"
import style0 from "./jefe_admin.vue?vue&type=style&index=0&id=1f67dd0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f67dd0c",
  null
  
)

export default component.exports